import i18n from "@/i18n";
import { get } from "lodash-es";

export default function getEntityTranslation<T>(object: T, property: string) {
    const lang = i18n.global.locale;
    if (!property) return get(object, lang + "Translation");
    return get(object, lang + "Translation." + property);
}
